import { FiltersTypeEnum, RankSortingLocatorComponent } from 'world-archery-lib';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, tap } from 'rxjs/operators';
import { FiltersAbstractService } from '../../common-page-components/classes/filters-abstract-service';
import * as i0 from "@angular/core";
export class EventsResultsFiltersService extends FiltersAbstractService {
    constructor() {
        super();
        this.level_id = new BehaviorSubject(undefined);
        this.filtersType = [
            {
                options: {
                    type: FiltersTypeEnum.TextSearch,
                    id: 'ertextfilter',
                    defaultTextValue: '',
                    text_subject: new BehaviorSubject('')
                }
            },
            {
                options: {
                    type: FiltersTypeEnum.ComboBox,
                    name_filter: 'Level:',
                    options_subject: new BehaviorSubject([
                        { name: 'All levels', id: [] },
                        { name: 'International events', id: [1, 2, 3, 4, 8] },
                        { name: 'Continental events', id: [5, 6, 7] },
                        { name: 'National events', id: [9, 10] }
                    ]),
                    option_name_property: 'name',
                    options_selected_subject: new BehaviorSubject({ name: 'All levels' }),
                    id: 'erdisciplinecombo'
                }
            },
            {
                options: {
                    type: FiltersTypeEnum.ComboBox,
                    name_filter: 'World ranking:',
                    options_subject: new BehaviorSubject([
                        { name: 'All' },
                        { name: 'Yes', value: 1 },
                        { name: 'No', value: -1 }
                    ]),
                    option_name_property: 'name',
                    options_selected_subject: new BehaviorSubject({
                        name: 'All'
                    }),
                    id: 'wrankingworldrankingeventcombo'
                }
            },
        ];
        /**
         * A subject to set if is World Ranking Event.
         *
         * @type {BehaviorSubject<number>}
         * @memberof EventsResultsFiltersService
         */
        this.isWorldRankingEvent = new BehaviorSubject(undefined);
        /**
         * Variable for get the sync status of world ranking filter.
         *
         * @memberof EventsResultsFiltersService
         */
        this.isWorldRankingSet = false;
        /**
         *
         * Subject of page number
         * @memberof EventsResultsFiltersService
         */
        this.pageNumber = new BehaviorSubject(0);
        /**
         *
         * Subject of actual page
         * @memberof EventsResultsFiltersService
         */
        this.pageActual = new BehaviorSubject(0);
        /**
         *
         * Subject of total items in the page
         * @memberof EventsResultsFiltersService
         */
        this.totalItems = new BehaviorSubject(0);
        /**
         *
         * Subject of the selected items per page count
         * @memberof EventsResultsFiltersService
         */
        this.pageCount = new BehaviorSubject(10);
        this.sortLocator = new RankSortingLocatorComponent();
        this.orderSubject = new BehaviorSubject(this.sortLocator);
        (this.filtersType[1].options).options_selected_subject.asObservable()
            .pipe(distinctUntilChanged(), tap(a => this.pageNumber.next(0))).pipe(tap(a => this.level_id.next(a))).pipe(tap(a => this.level_id.next(a))).subscribe();
        this.sortLocator.asc = false;
        this.sortLocator.sortingType = 'DATE';
    }
    /**
     *
     * Get an observable with all grouped filters of page
     * @returns {Observable<{
     *     text: string, //Belongs to text input
     *     level: Array<number>, //Array of levels id
     *     sort: RankSortingLocatorComponent, // sortLocator
     *     page_number: number, //Page number
     *     items_per_page: number, //Requested items per page
     *   }>}
     * @memberof EventsResultsFiltersService
     */
    getDataStreamWithFilters() {
        return combineLatest((this.filtersType[0].options).text_subject.asObservable().pipe(debounceTime(300), distinctUntilChanged(), tap(a => this.pageNumber.next(0))), this.level_id.asObservable(), this.orderSubject.asObservable(), this.pageNumber.asObservable(), this.pageCount.asObservable(), (this.filtersType[2]).options.options_selected_subject.asObservable()).pipe(map(([text, level_popular, sort, pageNumber, pageCount, isWorldRanking]) => {
            // Default values for sorts.
            let arr_level = [];
            if (level_popular.id.length === 0) {
            }
            arr_level = level_popular.id;
            const ret = {
                text: text,
                level: arr_level,
                sort: sort,
                page_number: pageNumber,
                items_per_page: pageCount,
                isWorldRanking: isWorldRanking.value
            };
            this.isWorldRankingSet = isWorldRanking.value != undefined ? isWorldRanking.value : undefined;
            return ret;
        }));
    }
    generateDefaultValues() {
    }
    /**
     * Get subject of order value
     *
     * @readonly
     * @type {Observable<RankSortingLocatorComponent>}
     * @memberof EventsResultsFiltersService
     */
    get orderValue() {
        return this.orderSubject.asObservable();
    }
    /**
     * Modifies and send next sort locator
     *
     * @memberof EventsResultsFiltersService
     */
    modifyOrderValue() {
        this.orderSubject.next(this.sortLocator);
    }
}
EventsResultsFiltersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventsResultsFiltersService_Factory() { return new EventsResultsFiltersService(); }, token: EventsResultsFiltersService, providedIn: "root" });
